import React, { createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAccount } from 'src/hooks'

import { useAccountSubscription } from 'src/hooks/subscriptions/use-account-subscription.hook'
import { EAccountSubscriptionPlans } from 'src/types'

interface AccountSubscriptionContextType {
  isActive: boolean | null
  isAccount: boolean
  isBillingHidden: boolean | undefined
  subscriptionPlan: EAccountSubscriptionPlans | undefined
  accountId: string | undefined
}

const AccountSubscriptionContext = createContext<AccountSubscriptionContextType | undefined>(
  undefined,
)

export const AccountSubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isActive, setIsActive] = useState<boolean | null>(null)
  const { accountId } = useParams()

  const { data: account } = useAccount()
  const { data: isSubscriptionActive, isLoading } = useAccountSubscription(accountId)

  useEffect(() => {
    if (!isLoading && typeof isSubscriptionActive === 'boolean') {
      setIsActive(isSubscriptionActive)
      return
    }
    setIsActive(null)
  }, [isLoading, isSubscriptionActive])

  return (
    <AccountSubscriptionContext.Provider
      value={{
        isActive: isActive,
        isAccount: !!accountId,
        isBillingHidden: account?.white_label?.billing_hidden,
        subscriptionPlan: account?.subscription_plan,
        accountId: accountId,
      }}
    >
      {children}
    </AccountSubscriptionContext.Provider>
  )
}

export const useAccountSubscsriptionPlan = () => {
  const context = useContext(AccountSubscriptionContext)
  if (context === undefined) {
    throw new Error('useAccountSubscsriptionPlan must be used within a AccountSubscriptionProvider')
  }
  return context
}
